import TopPartSection from './TopPartSection';

export default TopPartSection;
